export default "__VITE_ASSET__967aab64__"